import ShareIcon from '@mui/icons-material/Share'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { FC, useState } from 'react'

import { CustomerEntry } from '../../sdk'
import { CustomerLookupInput } from '../CustomerLookUp'
import { EmailAddressSelect } from '../EmailAddressSelect'

interface Props {
  defaultMessage: string
  open: boolean
  handleCancel: () => void
  handleSend: () => void
  customer?: CustomerEntry
}

export const ShareViaEmailDialog: FC<Props> = ({
  defaultMessage,
  open,
  handleCancel,
  handleSend,
  customer,
  ...props
}) => {
  const [emailAddress, setEmailAddress] = useState<string | undefined>('')

  const subject = 'InTune Auto Link'

  const mailUrl =
    'mailto:' + emailAddress + '?subject=' + subject + '&body=' + defaultMessage
  const gmailUrl =
    'https://mail.google.com/mail/?view=cm&fs=1&to=' +
    emailAddress +
    '&su=' +
    subject +
    '&body=' +
    defaultMessage

  const handleClose = () => {
    setEmailAddress(undefined)
    handleCancel()
  }

  return (
    <Dialog {...props} open={open} onClose={() => handleClose()}>
      <DialogTitle sx={{ fontWeight: 'bold' }}>Share via Email</DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        <Typography pb={2}>
          Select customer and email address to draft your message
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomerLookupInput
            customer={customer}
            handleCustomerChange={() => {}}
            withNumber={false}
            isClickable={false}
          />

          {customer && (
            <EmailAddressSelect
              customerId={customer.id!}
              emailAddress={emailAddress}
              handleEmailChange={(email) => setEmailAddress(email)}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ pt: 2 }}>
        <Button onClick={() => handleClose()} variant="text">
          Back
        </Button>
        {customer && emailAddress && (
          <Button
            onClick={() => {
              window.open(gmailUrl, '_blank')
              setEmailAddress(undefined)
              handleSend()
            }}
            variant="text">
            <ShareIcon sx={{ pl: 0, pr: 1 }} />
            Send via Gmail
          </Button>
        )}
        {customer && emailAddress && (
          <Button
            onClick={() => {
              window.open(mailUrl, '_blank')
              setEmailAddress(undefined)
              handleSend()
            }}
            variant="text">
            <ShareIcon sx={{ pl: 0, pr: 1 }} />
            Send via Default Mail
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
